import React, {Component} from 'react'
import {connect} from 'react-redux'
import {append} from 'ramda'
import {isEmail, nonEmptyString, validateObject} from '@/validation'
import {appSelectors} from '@/store'

import GoTrashcan from 'react-icons/lib/go/trashcan'
import EditField from '@/controls/edit-field'
import EditTextInline from '@/controls/edit-text-inline'
import type {Language} from '@/types'

import './email-adder.css'

type Props = {
  l: Language,
  label: string,
  entries: Array<Object>,
  delEmail: (number) => void,
}

const validators = {
  emailAddress: [nonEmptyString('Email address'), isEmail('Email address')],
}

const initialState = {
  firstName: '',
  lastName: '',
  emailAddress: '',
}

export class RawEmailAdder extends Component<Props> {
  constructor (props) {
    super(props)
    this.state = initialState
  }

  addEntry = () => {
    validateObject(validators, this.state)
      .fold(
        () => {
        },
        (x) => {
          this.props.onChange(append(x, this.props.entries))
          this.setState({
            ...initialState,
          })
        }
      )
  }

  buildEntry = (propName) => (val) => {
    this.setState({
      [propName]: val,
    })
  }

  updateEmailList (index, key, val) {
    let list = this.props.entries
    list[index][key] = val
    this.props.onChange(list)
  }

  isAddButtonDisabled = () => {
    if (this.state.emailAddress && this.state.emailAddress.trim()) {
      return false
    }
    return true
  }

  render = () =>
    <div className="form-group email-adder">
      <label>{this.props.label}
        <div>
          {this.props.entries && this.props.entries.length > 0
            ? <table className='table table-stripped table-bordered emails-table'>
              <thead>
                <tr>
                  <th width="10%">{this.props.l('Sno')}</th>
                  <th>{this.props.l('First name')}</th>
                  <th>{this.props.l('Last name')}</th>
                  <th>{this.props.l('Email address')}</th>
                  <th width="8%"></th>
                </tr>
              </thead>
              <tbody>
                {this.props.entries.map((e, index) =>
                  <tr key={index}>
                    <td width='8%'>{index + 1}</td>
                    <td>
                      <EditTextInline id={index} label={'firstName'} placeholder={this.props.l('First name')}
                        value={e.firstName} onUpdate={this.updateEmailList.bind(this)}
                      />
                    </td>
                    <td>
                      <EditTextInline id={index} label={'lastName'} placeholder={this.props.l('Last name')}
                        value={e.lastName} onUpdate={this.updateEmailList.bind(this)}
                      />
                    </td>
                    <td>
                      <EditTextInline id={index} label={'emailAddress'} placeholder={this.props.l('Email address')}
                        value={e.emailAddress} onUpdate={this.updateEmailList.bind(this)}
                        validators={validators['emailAddress']}/>
                    </td>
                    <td width='8%'><a onClick={() => this.props.delEmail(index)}><GoTrashcan/></a></td>
                  </tr>
                )}
              </tbody>
            </table>
            : <div>{this.props.l('There are no emails')}</div> }
        </div>
      </label>
      <div className="row">
        <div className="col-xs-3">
          <EditField
            label="First name"
            value={this.state.firstName}
            onChange={this.buildEntry('firstName')}
          />
        </div>
        <div className="col-xs-3">
          <EditField
            label="Last name"
            value={this.state.lastName}
            onChange={this.buildEntry('lastName')}
          />
        </div>
        <div className="col-xs-4">
          <EditField
            label="Email address"
            value={this.state.emailAddress}
            validators={validators['emailAddress']}
            onChange={this.buildEntry('emailAddress')}
          />
        </div>
        <div className="add-button">
          <button type="button" className="btn btn-success btn-block"
            onClick={this.addEntry} disabled={this.isAddButtonDisabled()}>{this.props.l('Add')}</button>
        </div>
      </div>
    </div>
}

const mapStateToProps = (state) => ({
  l: appSelectors.getL(state),
})

export default connect(
  mapStateToProps,
)(RawEmailAdder)



// WEBPACK FOOTER //
// ./src/views/forms/portfolio/email-adder.js